module.exports = __webpack_public_path__ + "summer/img/bg.9b67deb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/login/bg.png
// module id = aAhv
// module chunks = 39